const BoxShadow = {
    size: {
        small: ' 0rem 0rem .1rem .1rem ',
        medium: ' 0rem 0rem .5rem .5rem ',
        large: ' 0rem 0rem .75rem .75rem ',
    }
}

export default BoxShadow;